import {getPhoneString} from "../../../form/utils/get_phone_string";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IPostApplicationPayload} from "../../types/lead/IPostApplicationPayload";

export function getParsedLeadFormValues(leadFormValues: IApplicationFormValues): Omit<IPostApplicationPayload, "source" | "source_section"> {
    return {
        ...leadFormValues,
        phone: getPhoneString(leadFormValues.phone),
        financing_services: true,
        marketing_email: leadFormValues.marketing_email,
        marketing_sms: leadFormValues.marketing_sms,
        home_match_trigger: true
    };
}
import {getPhoneString} from "../../../form/utils/get_phone_string";
import {IApplicationFormValues} from "../../types/form/IApplicationFormValues";
import {IPostApplicationPayload} from "../../types/lead/IPostApplicationPayload";

export function getParsedLeadFormValues(leadFormValues: IApplicationFormValues): Omit<IPostApplicationPayload, "source" | "source_section"> {
    return {
        ...leadFormValues,
        phone: getPhoneString(leadFormValues.phone),
        financing_services: true,
        marketing_email: leadFormValues.marketing_email,
        marketing_sms: leadFormValues.marketing_sms,
        home_match_trigger: true
    };
}
